// Renders a minor-unit money amount using the active CurrencyConfig from
// store context. Always render money via this — never call formatMoney
// directly in feature code.
import { Typography } from 'antd';
import { formatMoney } from '@core/utils/money';
import { useStoreContextStore } from '@core/store/storeContextStore';

const { Text } = Typography;

export default function Price({
  amount,
  strike = false,
  muted = false,
  size = 'inherit',
  color,
  className,
}) {
  const currencyConfig = useStoreContextStore((s) => s.currencyConfig);

  if (amount == null) return null;

  const text = formatMoney(amount, currencyConfig ?? undefined);
  const style = {
    ...(size !== 'inherit' ? { fontSize: size } : {}),
    ...(color ? { color } : {}),
  };

  return (
    <Text
      className={className}
      delete={strike}
      type={muted ? 'secondary' : undefined}
      style={Object.keys(style).length ? style : undefined}
    >
      {text}
    </Text>
  );
}
